module.exports = __webpack_public_path__ + "media/images/icons/alert-eucalyptus-9c62062126886ad6dfa2d60637aedb3e.svg";